import ai4a1 from '../images/ai4a/img1.jpg';
import ai4a2 from '../images/ai4a/img2.jpg';
import ai4a3 from '../images/ai4a/img3.jpg';
import ai4a4 from '../images/ai4a/img4.jpg';

const ai4a_project = {
  title: 'A.I. For Anyone',
  description: 'A collection of blog posts I wrote to improve AI literacy among more than 50,000 teen readers.',

  sections: [],
  imageLink: [
    {
      title: 'Open Sourced #1: Today\'s Biases are Tomorrow\'s Technology',
      body: 'The recently invigorated Black Lives Matter movement has exposed systemic biases pervading our social structures and personal beliefs. How do human biases manifest in the AI we create and what can we do to fix it?',
      img: ai4a1,
      date: 'July 31, 2020',
      target: 'https://www.aiforanyone.org/post/open-sourced-1-todays-biases-are-tomorrows-technology',
    },
    {
      title: 'Open Sourced #2: What AI Can and Can\'t Do in the Fight Against Covid-19',
      body: 'AI is not the cure for COVID-19. Not today, not tomorrow, and not next year. But AI can help to detect the virus, limit its spread, and research potential vaccines.',
      img: ai4a2,
      date: 'August 21, 2020',
      target: 'https://www.aiforanyone.org/post/open-sourced-2-what-ai-can-and-cant-do-in-the-fight-against-covid-19',
    },
    {
      title: 'Open Sourced #3: You vs. AI',
      body: 'All the hype surrounding artificial intelligence (AI) got you bummed out about your human brain? Read this for a slight confidence booster.',
      img: ai4a3,
      date: 'September 18, 2020',
      target: 'https://www.aiforanyone.org/post/open-sourced-3-you-vs-ai',
    },
    {
      title: 'Open Sourced #4: Cyborg Politics',
      body: 'The 2020 US presidential election was riddled with threats to democracy like alleged voter fraud and refusal to commit a peaceful transfer of power. Let’s talk about how governments can (and can’t) use AI to promote democratic values.',
      img: ai4a4,
      date: 'December 25, 2020',
      target: 'https://www.aiforanyone.org/post/open-sourced-4-cyborg-politics',
    },
  ],
};

export default ai4a_project;